import parse from 'html-react-parser';

interface HtmlViewerProps {
    content: string
}
export const HtmlViewer = ({content} : HtmlViewerProps) => {
    return (
        <>{parse(content)}</>
    )
}